const ROOT = 'dashboard/settings/properties/domus/'

export default {
	store: `${ROOT}store-on-mobili`,
	show: `${ROOT}show-on-mobili/`
}
